"use client";

import Image from "next/image";
import { useTranslation } from "react-i18next";

const WHATSAPP_ICON_PATH = "/icon/whatsapp-icon.png";

interface WhatsAppIconProps {
  size?: number;
  className?: string;
}

export default function WhatsAppIcon({ size = 24, className = "" }: WhatsAppIconProps) {
  const { t } = useTranslation();

  return (
    <Image
      src={WHATSAPP_ICON_PATH}
      alt={t("images.whatsappAlt")}
      width={size}
      height={size}
      sizes={`${size}px`}
      className={`object-contain ${className}`}
    />
  );
}
